var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Send component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSend extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.9292 1.15505C20.4663 1.05408 19.9844 1.08683 19.5397 1.24933L2.80709 6.83204L2.80204 6.83376C2.38111 6.97754 2.00622 7.23111 1.7161 7.56828C1.4279 7.90321 1.23375 8.30856 1.15337 8.74294C1.07303 9.14047 1.09195 9.55173 1.20851 9.94029C1.32589 10.3315 1.53888 10.6878 1.82782 10.9765L5.87538 15.0241L5.74329 20.1168C5.73642 20.3819 5.87007 20.631 6.09481 20.7718C6.31955 20.9126 6.60195 20.9243 6.83753 20.8025L10.0031 19.1656L13.0136 22.1623C13.3128 22.4675 13.6862 22.6897 14.0972 22.8072C14.5087 22.9247 14.9436 22.9332 15.3592 22.8318C15.7748 22.7344 16.1584 22.5321 16.4736 22.2441C16.7896 21.9554 17.0261 21.5904 17.1604 21.184L17.1609 21.1827L22.7428 4.45253C22.9053 4.00774 22.9381 3.52582 22.8371 3.06298C22.7351 2.59565 22.5012 2.16743 22.1629 1.82921C21.8247 1.491 21.3965 1.257 20.9292 1.15505ZM19.853 2.72609L3.28689 8.25324L3.28475 8.25397C3.11748 8.31153 2.96851 8.41253 2.85312 8.54664C2.73723 8.68132 2.65941 8.8445 2.6277 9.01933L2.62434 9.03669C2.59206 9.19352 2.59924 9.3559 2.64525 9.50926C2.69126 9.66263 2.77465 9.80215 2.88793 9.91531L6.67917 13.7066L19.853 2.72609ZM7.37444 15.0798L7.27569 18.8872L9.79998 17.5819C10.0895 17.4322 10.4426 17.4866 10.6736 17.7166L14.0831 21.1105C14.2006 21.2309 14.3475 21.3186 14.5093 21.3649C14.6711 21.4111 14.8422 21.4143 15.0056 21.3741L15.0149 21.3718C15.1816 21.3331 15.3355 21.2521 15.4619 21.1367C15.5882 21.0212 15.6828 20.8752 15.7364 20.7127L15.7372 20.7103L21.3236 3.96679C21.3263 3.95878 21.3291 3.95081 21.332 3.9429C21.3955 3.77208 21.4109 3.58731 21.3769 3.40864L7.37444 15.0798Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSend.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSend.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSend.prototype, "size", void 0);
if (customElements.get('cat-icon-send') === undefined) {
    customElements.define('cat-icon-send', BlocksIconSend);
}
